import React, { Component } from 'react';
import { Form, FormGroup, FormControl, ControlLabel, Col, Button } from 'react-bootstrap';
import { getYearOptions } from '../../../services/dateServices';
import Api from '../../../../../Global/Modules/Api'
import { Link } from 'react-router-dom';
const FETCH_URL = "api/educations/lectureadmin"

class Voordracht extends Component {

    constructor() {
        super();
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.emptyForm = this.emptyForm.bind(this)

        this.state = {
            data: {
                type: '',
                name: '',
                institution: '',
                city: '',
                yearEnd: ''
            },
            errors: {}
        }
    }

    handleChange(event) {
        const target = event.target
        const name = target.name
        const value = target.value
        this.setState({ data: { ...this.state.data, [name]: value } })
    }

    // Function that will be executed when the submit button is pressed
    handleSubmit(event) {
        event.preventDefault()

        var formData = new FormData()
        Object.keys(this.state.data).forEach(e => {
            formData.append(e, this.state.data[e])
        })
        formData.append('MemberId', this.props.id)
        const file = this.fileInput.files[0]
        formData.append('file', file === undefined ? null : file)

        // Post formData to the API
        Api.PostApiWithFile(FETCH_URL, formData, this.props.history)
            .then(data => {
                alert("Voordracht added")
                window.location.href = '/admin/leden/lid/kennis/' + this.props.id
            })
    }

    emptyForm() {
        // TODO: Show some kind of message so the user knows that something has been created
        Api.print('Emptying form')
        const emptyData = {
            type: '',
            name: '',
            institution: '',
            city: '',
            yearEnd: ''
        }

        this.setState({ data: emptyData })
    }

    render() {
        let errors = this.state.errors
        return (
            <Form horizontal onSubmit={this.handleSubmit}>
                <FormGroup controlId="VoordrachtType">
                    <Col componentClass={ControlLabel} sm={4}>
                        Type
                    </Col>

                    <Col sm={6}>
                        <FormControl name="type" componentClass="select" value={this.state.data.type} onChange={this.handleChange} required>
                            <option value="">selecteer</option>
                            <option value="Eenvoudige voordracht (half uur)">Eenvoudige voordracht (half uur)</option>
                            <option value="Gastcollege (1 uur)">Gastcollege (1 uur)</option>
                            <option value="Workshop (dagdeel)">Workshop (dagdeel)</option>
                        </FormControl>
                        {Api.showError(errors, "type")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="VoordrachtNaamVoordracht">
                    <Col componentClass={ControlLabel} sm={4}>
                        Naam voordracht
                    </Col>
                    <Col sm={6}>
                        <FormControl name="name" type="text" value={this.state.data.name} onChange={this.handleChange} required />
                        {Api.showError(errors, "name")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="VoordrachtVoorWie">
                    <Col componentClass={ControlLabel} sm={4}>
                        Voor wie
                    </Col>
                    <Col sm={6}>
                        <FormControl name="institution" type="text" value={this.state.data.institution} onChange={this.handleChange} required />
                        {Api.showError(errors, "institution")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="VoordrachtPlaats">
                    <Col componentClass={ControlLabel} sm={4}>
                        Plaats
                    </Col>
                    <Col sm={6}>
                        <FormControl name="city" type="text" value={this.state.data.city} onChange={this.handleChange} required />
                        {Api.showError(errors, "city")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="VoordrachtJaar">
                    <Col componentClass={ControlLabel} sm={4}>
                        Jaar
                    </Col>

                    <Col sm={6}>
                        <FormControl name="yearEnd" componentClass="select" value={this.state.data.yearEnd} onChange={this.handleChange} required>
                            <option value="">selecteer</option>
                            {getYearOptions()}
                        </FormControl>
                        {Api.showError(errors, "yearEnd")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="VoordrachtUpload">
                    <Col componentClass={ControlLabel} sm={4}>
                        Diploma
                    </Col>

                    <Col sm={6}>
                        <FormControl type="File" inputRef={input => this.fileInput = input} />
                        {Api.showError(errors, "file")}
                    </Col>

                </FormGroup>

                <FormGroup>
                    <Col sm={2}>
                        <Link to={'/admin/leden/lid/kennis/' + this.props.id} className="btn btn-default">Terug</Link>
                    </Col>
                    <Col smOffset={8} sm={2}>
                        <Button type="submit">Voeg Toe</Button>
                    </Col>
                </FormGroup>
            </Form>
        );
    }
}

export default Voordracht;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Leden/Lid/Toevoegen/Voordracht.js